export default [
  {
    path: '/system/role',
    name: 'systemRole',
    meta: {
      title: '角色配置'
    },
    component: () =>
      import(/* webpackChunkName: "systemRole" */ '@/views/system/role/index.vue')
  },
  {
    path: '/system/role/add',
    name: 'addRole',
    meta: {
      title: '新建角色'
    },
    component: () =>
      import(/* webpackChunkName: "systemRole" */ '@/views/system/role/addRole.vue')
  },
  {
    path: '/system/account',
    name: 'systemAccount',
    meta: {
      title: '账号配置'
    },
    component: () =>
      import(
        /* webpackChunkName: "systemAccount" */ '@/views/system/account/index.vue'
      )
  },
  {
    path: '/system/account/add',
    name: 'systemAccountAdd',
    meta: {
      title: '账号配置'
    },
    component: () =>
      import(
        /* webpackChunkName: "systemAccount" */ '@/views/system/account/addAccount.vue'
      )
  },
  {
    path: '/system/log',
    name: 'systemLog',
    meta: {
      title: '操作日志'
    },
    component: () =>
      import(/* webpackChunkName: "systemLog" */ '@/views/system/log.vue')
  },
  {
    path: '/system/applet',
    name: 'systemApplet',
    meta: {
      title: '应用参数配置'
    },
    component: () =>
      import(/* webpackChunkName: "systemLog" */ '@/views/system/applet/index.vue')
  },
  {
    path: '/system/rewardsAndPunishments',
    name: 'rewardsAndPunishments',
    meta: {
      title: '奖惩设置（智慧运营）'
    },
    component: () =>
      import(/* webpackChunkName: "rewardsAndPunishments" */ '@/views/system/rewardsAndPunishments/index.vue')
  },
  {
    path: '/system/build',
    name: 'build',
    meta: {
      title: '舆情党建设置'
    },
    component: () =>
      import(/* webpackChunkName: "rewardsAndPunishments" */ '@/views/system/build/index.vue')
  },
  {
    path: '/system/watch',
    name: 'watch',
    meta: {
      title: '查看舆情党建'
    },
    component: () =>
      import(/* webpackChunkName: "rewardsAndPunishments" */ '@/views/system/build/components/watch.vue')
  },
  {
    path: '/system/tzyq',
    name: 'tzyq',
    meta: {
      title: '添加通知/舆情'
    },
    component: () =>
      import(/* webpackChunkName: "rewardsAndPunishments" */ '@/views/system/build/components/tzyq.vue')
  },
  {
    path: '/system/dj',
    name: 'dj',
    meta: {
      title: '添加党建'
    },
    component: () =>
      import(/* webpackChunkName: "rewardsAndPunishments" */ '@/views/system/build/components/dj.vue')
  },

 
  {
    path: '/system/operation/personConfig',
    name: 'personConfig',
    meta: {
      title: '运用人员账号管理'
    },
    component: () =>
      import(/* webpackChunkName: "personConfig" */ '@/views/system/operation/personConfig/list.vue')
  },
  {
    path: '/system/operation/personConfigDetail',
    name: 'personConfigDetail',
    meta: {
      title: '新增账号'
    },
    component: () =>
      import(/* webpackChunkName: "personConfigDetail" */ '@/views/system/operation/personConfig/detail.vue')
  },
  {
    path: '/system/punch/clock',
    name: 'clock',
    meta: {
      title: '运用人员考勤分析'
    },
    component: () =>
      import(/* webpackChunkName: "personConfigDetail" */ '@/views/system/punch/clock.vue')
  },
  {
    path: '/system/grade/ranking',
    name: 'ranking',
    meta: {
      title: '运用人员等级排名'
    },
    component: () =>
      import(/* webpackChunkName: "personConfigDetail" */ '@/views/system/grade/ranking.vue')
  }

]